import type { AnyEventObject } from 'xstate';

export default (_context: any, event: AnyEventObject): boolean => !event.data;
